export default "__VITE_ASSET__DhkMHCCN__"